export const USER_RESET_PASSWORD_REQUEST = "RESET_PASSWORD/USER_RESET_PASSWORD_REQUEST";
export const USER_RESET_PASSWORD_SUCCESS = "RESET_PASSWORD/USER_RESET_PASSWORD_SUCCESS";
export const USER_RESET_PASSWORD_FAILURE = "RESET_PASSWORD/USER_RESET_PASSWORD_FAILURE";

export const USER_CHECK_TOKEN_REQUEST = "RESET_PASSWORD/USER_CHECK_TOKEN_REQUEST";
export const USER_CHECK_TOKEN_SUCCESS = "CHECK_TOKEN/USER_CHECK_TOKEN_SUCCESS";
export const USER_CHECK_TOKEN_FAILURE = "CHECK_TOKEN/USER_CHECK_TOKEN_FAILURE";


// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/ResetPassword/constants.js